var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { BaseModule } from './../commons/BaseModule';
import App from './components/App.vue';
var AppModule = (function (_super) {
    __extends(AppModule, _super);
    function AppModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.appOptions = {
                el: '#app',
                components: { App: App },
                render: function (h) { return h(App); }
            };
            Vue.prototype.$getAppInstance = getAppInstance.bind(_this);
            Vue.prototype.$getModuleByType = _this.getModuleByType.bind(_this);
            _this.preInstallModules().then(function (result) {
                console.log('app pre-installation successfull');
                return _this.finalizeInstall(options);
            }).then(function (result) {
                console.log('app finalized installation successfull');
                resolve(true);
            }).catch(function (error) {
                console.log('error while installing app', error);
                reject();
            });
        });
    };
    AppModule.prototype.preInstallModules = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, module_1, result, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.modules;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 6];
                        module_1 = _a[_i];
                        console.log('pre-installing', module_1.constructor.name);
                        result = void 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4, module_1.preInstall({
                                appModule: this
                            })];
                    case 3:
                        result = _b.sent();
                        console.log('pre-installation done', module_1.constructor.name, result);
                        return [3, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.log('pre-installation error', module_1.constructor.name, error_1);
                        throw new Error(error_1);
                    case 5:
                        _i++;
                        return [3, 1];
                    case 6: return [2];
                }
            });
        });
    };
    AppModule.prototype.finalizeInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.finalizeInstallModules().then(function (result) {
                console.log('app loaded successfully');
            }).catch(function (error) {
                console.log('error while loading app', error);
            }).finally(function () {
                resolve(true);
            });
        });
    };
    AppModule.prototype.finalizeInstallModules = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, module_2, result, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.modules;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3, 6];
                        module_2 = _a[_i];
                        console.log('finalize installation', module_2.constructor.name);
                        result = void 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4, module_2.finalizeInstall({
                                appModule: this
                            })];
                    case 3:
                        result = _b.sent();
                        console.log('finalize installation done', module_2.constructor.name, result);
                        return [3, 5];
                    case 4:
                        error_2 = _b.sent();
                        console.log('finalize installation error', module_2.constructor.name, error_2);
                        throw new Error(error_2);
                    case 5:
                        _i++;
                        return [3, 1];
                    case 6: return [2];
                }
            });
        });
    };
    AppModule.prototype.mountApp = function () {
        console.log('mounting app');
        this.app = new Vue(this.appOptions);
    };
    return AppModule;
}(BaseModule));
export default AppModule;
var instance = new AppModule();
export var appModule = instance;
export var app = appModule.app;
export function getAppInstance() {
    return instance;
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/app/index.ts
// module id = null
// module chunks = 